<template lang="pug">
	section(:class="{'force-mobile': forceMobile}")
		p.mb-5
			| Knowing this helps us better customize your experience and offer better recommendations
			.error-message(v-show="errors.select") Please select an option

		.d-none.d-md-block.block-questions
			.steps-elements.mb-5
				.steps-element.mb-5.mr-5.mr-lg-0.mb-lg-0(@click="select('learn')" :class="{'active': nextStep == 'learn'}")
					span.icon-check
						svg(xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 29 29")
							g(fill="none" fill-rule="evenodd" transform="translate(2 2)")
								rect(width="26.25" height="26.25" x="-.625" y="-.625" fill="#47B5F7" stroke="#106CC6" stroke-width="1.25" rx="12.5")
								path(fill="#FFF" fill-rule="nonzero" d="M10.625 13.75l-2.5-2.5-1.875 1.875 4.375 4.375 8.125-8.125L16.875 7.5z")

					.steps-image
						img(:src="`${$store.state.config.s3ResourceHost}/images/icon-books-apple.svg`" alt="Learn")
					.steps-title LEARN
					p.steps-copy I want to learn more about college savings
				.steps-element.mb-5.mb-lg-0(@click="select('open-a-plan')" :class="{'active': nextStep == 'open-a-plan'}")
					span.icon-check
						svg(xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 29 29")
							g(fill="none" fill-rule="evenodd" transform="translate(2 2)")
								rect(width="26.25" height="26.25" x="-.625" y="-.625" fill="#47B5F7" stroke="#106CC6" stroke-width="1.25" rx="12.5")
								path(fill="#FFF" fill-rule="nonzero" d="M10.625 13.75l-2.5-2.5-1.875 1.875 4.375 4.375 8.125-8.125L16.875 7.5z")
					.steps-image
						img(:src="`${$store.state.config.s3ResourceHost}/images/icon-open-plan.svg`" alt="Open a plan")
					.steps-title OPEN A PLAN
					p.steps-copy I'm ready to open a 529 plan
				.steps-element.mb-5.mb-lg-0(@click="select('grow')" :class="{'active': nextStep == 'grow'}")
					span.icon-check
						svg(xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 29 29")
							g(fill="none" fill-rule="evenodd" transform="translate(2 2)")
								rect(width="26.25" height="26.25" x="-.625" y="-.625" fill="#47B5F7" stroke="#106CC6" stroke-width="1.25" rx="12.5")
								path(fill="#FFF" fill-rule="nonzero" d="M10.625 13.75l-2.5-2.5-1.875 1.875 4.375 4.375 8.125-8.125L16.875 7.5z")
					.steps-image
						img(:src="`${$store.state.config.s3ResourceHost}/images/icon-grow.svg`" alt="Grow")
					.steps-title GROW
					p.steps-copy I want to accelerate my 529 plan savings

				br.d-lg-none


			br
			.continue-button
				sfc-button.mr-4(:blue="false" :back-arrow="true" @click="back()")
				sfc-button(text="NEXT" :blue="true" :continue-arrow="true" @click="next()")
		.d-block.d-md-none.radio-questions
			section.radio-wrap
				.radio
					sfc-radio(v-model="nextStep" :radio-value="`learn`" label="I want to <b>learn more</b> about college savings" @click="nextDirect('learn')" name="learn")
			section.radio-wrap
				.radio
					sfc-radio(v-model="nextStep" :radio-value="`open-a-plan`" label="I'm ready to <b>open a 529 plan</b>" @click="nextDirect('open-a-plan')" name="open-a-plan")
			section.radio-wrap
				.radio
					sfc-radio(v-model="nextStep" :radio-value="`grow`" label="I want to accelerate my 529 plan savings" @click="nextDirect('grow')" name="grow")

			.continue-button
				sfc-button.mr-4(:blue="false" :back-arrow="true" @click="back()")

</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

.error
	color: red

.steps-elements
	display flex
	flex-direction row
	justify-content: space-evenly
	@media (max-width: 991px)
		display block
		text-align center
	@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)
		display block
		text-align center

	.steps-element
		cursor pointer
		border solid 1px #afb6cc
		background-color #ffffff
		max-width 165px
		width 100%
		padding 20px 15px
		sfc-box-shadow-card()
		border-radius()
		position relative
		@media (max-width: 991px)
			width 200px
			height 230px
			display inline-block
			vertical-align middle
		@media (max-width: 408px)
			max-width 130px
			margin-right 10px!important
		@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)
			display inline-block
			vertical-align middle
			margin 0px 9px !important
			&:first-child
				margin-left 0 !important
			&:last-child
				margin-right 0 !important
		.soon
			text-transform: uppercase
			font-size: body-font-size-xxs
			background-color: sfc-pale-gray
			font-weight: body-font-weight-strong
			color: #FFF
			line-height: body-font-line-height-xs
			padding: 2px 5px
			border-radius(2px)
			position absolute
			right 5px
			top 5px
			display: block
			z-index 10
		.icon-check
			position absolute
			right -14px
			top -10px
			display none
			z-index 10
		&.active
			sfc-box-shadow-card-active()
			border solid 1px sfc-royal-blue
			background-color sfc-pale-blue
			.icon-check
				display inline-block
		.steps-image
			text-align center
			img
				height 38px
			margin-bottom 15px
	.steps-copy
		text-align center
		font-size: body-font-size-sm
		font-weight: body-font-weight
		margin 0px
		line-height: 1.5
	.steps-title
		text-align: center
		margin-top: 10px
		font-size: body-font-size-sm
		font-weight: body-font-weight-strong
		color: body-font-color
		margin-bottom: 15px
	.disabled
		opacity: 0.40
		cursor: not-allowed
.error-message
	margin-bottom: 20px
	background-color: sfc-brick
	border: 1px solid #d0021b
	border-radius()
	padding: 5px 15px
	color: #fff

.continue-button
	margin-top: 30px

section.force-mobile
	@media (min-width: 768px)
		.block-questions
			display: none !important
		.radio-questions
			display: block !important

</style>

<script>

import SfcButton from '@/common/components/sfc-button'
import SfcRadio from '@/common/components/inputs/v2/radio'
import SfcTrackingService from "@/lib/sfc-tracking-service"

export default {

	props: {
		forceMobile: {
			default: false
		}
	},

	components:{
		SfcRadio,
		SfcButton
	},

	data() {
		return {
			errors: {
				select: false
			},
			nextStep: undefined,
			progressLength: 15
		}
	},

	methods: {

		select(nextStep){
			this.nextStep = nextStep
			this.validate()
		},

		back(){

			let title = "How old is your child?"

			this.$emit('next', -1*this.progressLength, title, "sfc-how-old-is-your-child")
		},

		validate(){
			this.errors.select = false
			if(!this.nextStep){
				this.errors.select = true
				return false
			}
			return true
		},

		next(){
			if(!this.validate()){
				return
			}

			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "next_step_v3", value: this.nextStep})
			this.$root.$emit('nextStepChange')

			let answer = this.nextStep.replaceAll("-", " ");
			SfcTrackingService.trackAnalyticsAction("Savings Center Onboarding", "How can we help - next", answer, 0)

			this.$emit('next', this.progressLength, "Enter your email address", "sfc-create-your-account")
		},

		nextDirect(value){
			this.$store.commit('updateCollegeSavingsUserOnboarding',{part: "next_step_v3", value: value})

			let answer = value.replaceAll("-", " ");
			SfcTrackingService.trackAnalyticsAction("Savings Center Onboarding", "How can we help - next", answer, 0)
			this.$emit('next', this.progressLength, "Enter your email address", "sfc-create-your-account")
		},
	}

}
</script>
